import client from './fetch'

export const getBoutiqueAvailabilities = ({ apiBaseUrl, id, language }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getBoutiqueAvailabilities',
      boutiqueId: id,
      language
    }
  }).then(data => {
    return data.filter(el => !el.isClosed)
  })
}

export const getTimeSlotsByDateAndType = ({ apiBaseUrl, date, boutiqueId, type }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getTimeSlotsByDateAndType',
      date,
      boutiqueId,
      ...(type && { type }),
      useBoutiqueDuration: true
    }
  }).then(data => {
    return data
  })
}

export const getPhonesValidation = ({ apiBaseUrl }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getPhonesValidation'
    }
  }).then(data => {
    return Object.values(data.records || [])
  })
}

export const getMaisonConfig = ({ apiBaseUrl, maisonId, language }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getMaisonConfigurations',
      maisonId,
      language
    }
  }).then(data => {
    return {
      enabledLanguages: data.enabledLanguages,
      enabledCountries: data.enabledCountries,
      configurations: data.configurations[0],
      labels: data.labels.reduce((acc, val) => {
        if (!acc[val.pageName]) {
          acc[val.pageName] = []
        }
        const res = {
          name: val.name,
          value: val.value,
          ...(val.translations.length > 0 ? val.translations[0] : {})
        }
        acc[val.pageName].push(res)
        return acc
      }, {})
    }
  })
}

export const getBoutiques = ({ apiBaseUrl, maisonId, country, language }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getBoutiquesId',
      maisonId,
      countryCode: country,
      language
    }
  }).then(data => {
    return (data[0] && data[0].boutiques) || []
  })
}

export const getBoutiqueServices = ({ apiBaseUrl, boutiqueId, language }) => {
  return client(`${apiBaseUrl}/v2`, {
    params: {
      apiMethod: 'getBoutiqueServicesV2',
      boutiqueId,
      language
    }
  }).then(data => {
    return data
  })
}

export const getAllCountries = ({ apiBaseUrl, language }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getAllCountries',
      language
    }
  }).then(data => {
    return data
  })
}

export const getSpokenLanguages = ({ apiBaseUrl, id, language }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getBoutiqueSpokenLanguages',
      boutiqueId: id,
      language
    }
  }).then(data => {
    return (data || []).sort((a, b) => {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })
  })
}

export const getRecaptchaKey = ({ apiBaseUrl }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'getRecaptchaKey'
    }
  })
    .then(res => res.recaptchaKey)
    .catch(err => console.log('getRecaptchaKeyMethod: ', err))
}

export const createNewAppointment = ({ apiBaseUrl, boutiqueId, body }) => {
  return client(`${apiBaseUrl}/v1`, {
    params: {
      apiMethod: 'createNewAppointmentCanvas',
      boutiqueId
    },
    body
  }).then(() => {
    return true
  })
}
